
import { useState } from "react";
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
} from "@/components/ui/navigation-menu";
import NavbarLogo from "./NavbarLogo";
import NavLinks from "./NavLinks";
import AuthButtons from "./AuthButtons";
import MobileMenu from "./MobileMenu";
import NavbarActions from "./NavbarActions";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-white border-b border-gray-200 dark:bg-gray-900 dark:border-gray-700">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <NavbarLogo />
        
        {/* Right-aligned items: NavbarActions and AuthButtons */}
        <div className="flex items-center space-x-3">
          {/* Desktop Navigation on the right */}
          <div className="hidden md:flex items-center space-x-3">
            <AuthButtons />
            <NavbarActions />
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden">
            <MobileMenu isOpen={isMenuOpen} toggleMenu={toggleMenu} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
